/** Generated by scripts/stampBuildInfo.cjs — do not edit manually. */
export const APP_BUILD_VERSION = "0.1.98";
export const APP_BUILD_ISO_TIME = "2026-11-04T17:53:36.695Z";
export const APP_PLAY_VERSION_CODE = 12;
export const APP_PLAY_VERSION_NAME = "1.0.12";
